RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, moment) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const UserFilter = RivalIQ.views.ItemView.mixin({
        template: '#reportsUserFilterTemplate',
        tagName: 'span',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            DropdownSelector: {
                initialTrigger: true
            }
        },

        onSelectDropdown: function (data) {
            const me = this;
            me.setProps('account_user_id', data.userId);
        },

        loadData: function (callback) {
            const me = this;

            RivalIQ.data.users.fetch()
                .done(function (users) {
                    me.collection = users;

                    callback();
                });
        },

        onRenderLoaded: function () {
            const me = this;

            // No need to show the picker if the account only has one user
            if (me.collection.length === 1) {
                me.$el.hide();
            }
        },

        serializeData: function () {
            const me = this;
            return {
                users: me.collection.toJSON()
            };
        }
    });

    UserFilter.getItemViewOptionsFromConfig = function (config, model) {
        return {
            model: model.get('model')
        };
    };

    widgets.ReportCenterItem = Marionette.ItemView.extend({
        template: '#reportCenterItemTemplate',
        tagName: 'tr',
        includeTitle: true,
        includeRecipients: false,

        ui: {
            recipients: '.x-recipients',
            action: '.x-action',
            scheduledIndicator: '.fa-clock-o'
        },

        modelEvents: {
            'change:export_status_id': 'render'
        },

        serializeData: function () {
            const me = this;
            return _.extend(me.model.toJSON(), {
                name: me.model.getTitle(),
                icon: me.model.getIcon(),
                isBuilding: me.model.isBuilding(),
                isFailed: me.model.isFailed(),
                isScheduled: me.model.isScheduled(),
                downloadUrl: RivalIQ.state.product.get('urlBasepath') + me.model.getDownloadPath()
            });
        },

        templateHelpers: function () {
            const me = this;

            const timezoneOffset = -1 * moment.tz.zone(RivalIQ.state.landscape.get('timezone')).utcOffset(new Date());

            return {
                s: s,
                ownerName: function () {
                    const owner = me.getOption('user');
                    if (owner) {
                        return [owner.get('first_name'), owner.get('last_name')].join(' ');
                    } else {
                        return 'Unknown';
                    }
                },
                createdAt: moment(me.model.get('created_at')).utcOffset(timezoneOffset).format('MMMM DD YYYY LT'),
                status: RivalIQ.export.enums.status,
                includeTitle: me.getOption('includeTitle'),
                includeRecipients: me.getOption('includeRecipients'),
                recipients: me.getRecipients()
            };
        },

        getRecipients: function () {
            const me = this;
            const emails = me.model.get('data').spec.emails;
            return (emails ? emails : [me.model.get('data').spec.email]);
        },

        onBeforeShow: function () {
            const me = this;

            me.ui.recipients.tooltip({
                title: s.toSentence(me.getRecipients()),
                trigger: 'hover'
            });

            me.ui.scheduledIndicator.tooltip();
        }
    });

    const EmptyView = Marionette.ItemView.extend({
        template: '#reportCenterEmptyTemplate',
        tagName: 'tr'
    });

    const ReportCenter = widgets.ReportCenter = RivalIQ.views.CompositeView.mixin({
        template: '#reportCenterTemplate',
        childView: widgets.ReportCenterItem,
        childViewContainer: '.x-report-list',
        emptyView: EmptyView,

        pollStatus: true,

        mixins: {
            Props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        loadData: function (callback) {
            const me = this;

            const attributes = {
                pollStatus: me.getOption('pollStatus'),
                reportScheduleId: me.getProp('reportScheduleId') || undefined
            };

            $.when(
                RivalIQ.data.users.fetch(),
                RivalIQ.export.data.exports.fetch(attributes)
            ).done(function (users, exports) {
                me.users = users;
                me.collection = exports;
                callback();
            });
        },

        childViewOptions: function (child) {
            const me = this;

            return {
                user: me.users.get(child.get('account_user_id')),
                includeTitle: me.getOption('includeTitle'),
                includeRecipients: me.getOption('includeRecipients')
            };
        },

        filter: function (child) {
            const me = this;

            return !child.get('data').spec.hideFromDownloads &&
                   !(child.isFailed() && child.get('created_at') < moment.utc().subtract(3, 'days')) &&
                   (!me.getProp('account_user_id') || me.getProp('account_user_id') === child.get('account_user_id')) &&
                   (!me.getProp('dateId') || child.get('created_at') > App.data.dates.get(me.getProp('dateId')).get('mainPeriodStart')) &&
                   (!me.getProp('filetype') || me.getProp('filetype') === child.get('export_type_id'));
        }
    });

    const WrapperView = Dashboard.views.DetailsLayout.extend({

        template: '#dashboardWidgetAlternateDetailLayoutTemplate',

        showToolbarActions: function () {
            const me = this;

            me.actions.show(new UserFilter({
                dashboardModel: me.dashboardModel
            }));

            me.actions.show(new App.widgets.FiletypeFilter({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });

            me.actions.show(new App.widgets.DateFilter({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });
        },
        showLeftToolbarActions: _.noop
    });

    const ReportCenterWidget = Dashboard.models.Widget.extend({
        title: 'Report Center',
        description: RivalIQ.strings.report_center_info,
        export: false,
        view: ReportCenter,
        getDetailWrapperView: function () {
            return WrapperView;
        },
        hasFooter: _.constant(false),
        processProps: function (props) {
            _.defaults(props, {
                dateId: App.data.dates.first().id
            });

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.REPORT_CENTER, ReportCenterWidget);

}, window.s, window.moment);
